import { FC } from 'react';
import { Box } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

import { SearchingButton } from './FindSuggestionsButton.styles';

interface FindSuggestionsButtonProps {
  onClick: () => void;
  isSearching: boolean;
  disabled: boolean;
}

// Reserve both label widths so searching cannot move the adjacent hint.
export const FindSuggestionsButton: FC<FindSuggestionsButtonProps> = ({ onClick, isSearching, disabled }) => (
  <Box display="inline-grid" flexShrink={0} sx={{ '& > *': { gridArea: '1 / 1', justifySelf: 'start' } }}>
    <Button
      color="secondary"
      onClick={onClick}
      disabled={disabled || isSearching}
      style={{ visibility: isSearching ? 'hidden' : 'visible' }}
      aria-hidden={isSearching}
    >
      Find Ride Suggestions
    </Button>
    <SearchingButton
      aria-label="searching all rides"
      aria-hidden={!isSearching}
      style={{ visibility: isSearching ? 'visible' : 'hidden' }}
    >
      Searching all rides...
    </SearchingButton>
  </Box>
);
